module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"notRecorded":"Video call was not recorded"}}')
  delete Component.options._Ctor
}
